import { SVG } from 'Common/commonsvg';
import React, { useState, useEffect } from 'react';
import { Collapse } from 'reactstrap';

type Props = {
  title?: string;
  discription?: string;
  titleclass?: string;
  tsize?: 'sm' | 'md' | 'lg';
  size: 'sm' | 'md' | 'lg';
  className?: string;
  children: React.JSX.Element;
  rightchild?: React.JSX.Element;
  collapsible?: boolean; // ✅ new prop — enable collapse
  defaultOpen?: boolean; // ✅ new prop — default collapsed/expanded
  setOpen?: (val: boolean) => void; // ✅ optional callback
};

export const FormC: React.FC<Props> = ({
  title,
  rightchild,
  discription,
  titleclass,
  tsize = 'sm',
  size,
  className,
  children,
  collapsible = false,
  defaultOpen = true,
  setOpen,
}) => {
  const InputSize = {
    sm: 'Title-small',
    md: 'Title-medium',
    lg: 'Title-large',
  };
  const CardSize = {
    sm: 'Card-small',
    md: 'Card-medium',
    lg: 'Card-large',
  };

  // collapse state
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [hoverIcon, setHoverIcon] = useState(false);

  useEffect(() => {
    setIsOpen(defaultOpen);
    setOpen?.(defaultOpen);
  }, [defaultOpen]);

  const toggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    setOpen?.(newState);
  };

  return (
    <div
      className={` ${className || ''} card-common ${CardSize[size]}`}
      onMouseEnter={() => {
        if (collapsible) setHoverIcon(true);
      }}
      onMouseLeave={() => {
        if (collapsible) setHoverIcon(false);
      }}
    >
      <div className="h-100">
        <div
          className={`d-flex justify-content-between align-items-center ${
            collapsible ? 'cursor-pointer' : ''
          }`}
          onClick={collapsible ? toggle : undefined}
        >
          {title && (
            <div className="pt-3 ps-3 pe-3 pb-3 d-flex align-items-center gap-2">
              {collapsible && (
                <div
                  style={{
                    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease',
                  }}
                >
                  {hoverIcon ? SVG.rightarrow : SVG.rightarrow}
                </div>
              )}
              <div>
              <h4
                className={`mb-0 ${titleclass || ''} ${InputSize[tsize]}`}
                style={{
                  fontWeight: 600,
                  // color: hoverIcon ? '#1E293B' : '#929292',
                }}
              >
                {title}
              </h4>
              {discription && (
                <h4 className={`mb-0 mt-2 ${titleclass} ${InputSize[tsize || '']}`}>{discription}</h4>
              )}
              </div>
            </div>
          )}
          {rightchild && <div className="pt-3 ps-3 pe-3 pb-3">{rightchild}</div>}
        </div>

        <Collapse isOpen={!collapsible || isOpen}>
          {title && <hr className="hr-formC" />}
          <div className="p-3 form-body h-100" style={{overflow:"auto"}}>{children}</div>
        </Collapse>
      </div>
    </div>
  );
};
